import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="toast"
export default class extends Controller {
  static values = { 
    autoDismiss: Boolean,
    type: String 
  }

  connect() {
    // Animate in
    this.element.classList.add("translate-x-0", "opacity-100")
    this.element.classList.remove("translate-x-full", "opacity-0")

    // Auto-dismiss if enabled
    if (this.autoDismissValue) {
      this.timeout = setTimeout(() => {
        this.dismiss()
      }, this.getDismissDelay())
    }
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  dismiss() {
    // Animate out
    this.element.classList.add("translate-x-full", "opacity-0")
    this.element.classList.remove("translate-x-0", "opacity-100")

    // Remove from DOM after animation
    setTimeout(() => {
      if (this.element.parentNode) {
        this.element.remove()
      }
    }, 300)
  }

  getDismissDelay() {
    // Different delays based on toast type
    switch (this.typeValue) {
      case 'success':
        return 4000 // 4 seconds for success messages
      case 'error':
        return 8000 // 8 seconds for errors (more time to read)
      case 'warning':
        return 6000 // 6 seconds for warnings
      default:
        return 5000 // 5 seconds default
    }
  }
}
